export default __webpack_public_path__ + "static/media/8-mountains-bg-front.097df873.png";